export const ROUTE_PATHS = {
  // 'Pet Profiles (WIP)': '/pet-profiles',
  // 'Photo Contest': '/photo-contest',
  "User Profiles": "/user-profiles",
  "Pet Medical Records": "/pet-medical-records",
  "Get Clinic Summary": "/get-clinic-summary",
  "Feature Configurator": "/feature-configurator",
  "Practice Config Tool": "/practice-config-tool",
  "Audit Logs": "/audit-logs",
};

export const API_URL = "https://kintopia-api.dev.kinship.tv";
